import React, { useEffect, useState, Fragment, useContext, createRef  } from 'react';
import { useSelector, connect } from 'react-redux';
import { setObjectCount } from 'actions/objectActions';
import LocaleContext from 'constants/localization';
import LocalizedStrings from 'react-localization';
import Form from 'react-bootstrap/Form';

const DocumentCountSelector = ({setObjectCount}) => {
  const LS = useContext(LocaleContext);
  localizedStrings.setLanguage(LS.getLanguage());
  
  const inputRef = createRef();
  
  const iframeDocument = document.querySelector("#mainframe").contentDocument;
  const thumbnails = iframeDocument.querySelector("#addContentThumbnails");
  const observeTarget = target => callback => {
  const mutationObserver = new MutationObserver(callback);
    mutationObserver.observe(target, { childList: true });
  };

  const observeThumbnails = observeTarget(thumbnails);

  const checkIsFileAdded = () => !!iframeDocument.querySelector(".tinyResult");
  
  const [fileAdded, setFileAdded] = useState(checkIsFileAdded());
  const [disabled, setDisabled] = useState(fileAdded);
  const [error, setError] = useState(null);
  const [documentCount, setDocumentCount] = useState('1');
  
  const objectLimit = 250;
  
  useEffect(() => {
    observeThumbnails((mutationRecord, observer) => {
      setFileAdded(checkIsFileAdded());
    });
  }, []);
  
  useEffect(() => {
    setDisabled(fileAdded);
    if(fileAdded){
      setDocumentCount('');
    }else{
	  setDocumentCount('1');
    }
  }, [fileAdded]);
  
  useEffect(() => {
	setObjectCount(documentCount);
  }, [documentCount]);
  
  let onChange = e => {
	let newDocumentCount = e.target.value;
	if(newDocumentCount > objectLimit){
		newDocumentCount = objectLimit;
		setError(localizedStrings.valueTooLarge+" "+objectLimit);
		setDocumentCount(newDocumentCount);
	}else{
		setError(null);
		setDocumentCount(newDocumentCount);
	}
  };

  const defaultProps = {
    onChange,
    value: documentCount,
    disabled: disabled,
    ref: inputRef,
    onWheel: () => inputRef.current.blur() // SPEC-292 disable scroll
  };

  return (
    <Fragment>
      <label>{LS.objectCount}</label>
      <Form.Control min={'1'} max={objectLimit} step={'1'} 
        type="number" {...defaultProps}  pattern={'\\d*'} />
      { error && <p className="text-danger">{error}</p> }
    </Fragment>
  );
};

const localizedStrings = new LocalizedStrings({
  fi: {
    valueTooLarge: 'Antamasi arvo on liian suuri. Suurin mahdollinen arvo on',
  },
  en: {
    valueTooLarge: 'Value is too large. Maximum allowed value is',
  },
  sv: {
	valueTooLarge: 'Värdet är för stort. Högsta tillåtna värde är',
  }
});

export default connect(null, {setObjectCount})(DocumentCountSelector);